import React, { Suspense, lazy, useState } from "react";
import Categories from "./Categories";
import MenuItems from "./MenuItems";
import "./Portfolio.css";

const LazyMenuItems = lazy(() => import("./MenuItems"));

function Portfolio({
  dataList,
  allCategories,
  headingTitle,
  description = false,
}) {
  const [allCategoriesLink, setAllCategoriesLink] = useState(allCategories);
  const [categories, setCategories] = useState(allCategoriesLink);
  const [menuItems, setMenuItems] = useState(dataList);

  const filter = (category) => {
    if (category === "fas fa-globe") {
      setMenuItems(dataList);
      return;
    }

    const filteredData = dataList.filter((item) => {
      return item.categoryLink === category || item.tagLink === category;
    });
    setMenuItems(filteredData);
  };

  return (
    <>
      <div className="container p-3 mb-5 bg-body rounded">
        <div
          className="section-title"
          style={{ marginBottom: "1rem", marginTop: "4rem" }}
        >
          <h2>{headingTitle}</h2>
        </div>
        <div className="PortfolioPage" style={{ marginBottom: "4rem" }}>
          <div className="portfolios-data">
            <Categories filter={filter} categories={categories} />
            <Suspense fallback={<div>Loading...</div>}>
              <LazyMenuItems menuItem={menuItems} description={description} />
            </Suspense>
          </div>
        </div>
      </div>
    </>
  );
}

export default Portfolio;
